import BaseApi from '@/services/base.api.js';

class LandingApi extends BaseApi {
  async leaveComment(data) {
    let { fullName, email, message } = data;
    let client = await this.getClientWithoutToken();
    return client({
      method: 'post',
      url: `${this.basicAuthUrl}landing/feedback?Name=${fullName}&Email=${email}&Message=${message}`,
      data: data
    });
  }

  async getHtmlContent(url) {
    let client = await this.getClientWithoutToken();
    return client({
      method: 'get',
      url,
    });    
  }
}

export default LandingApi;
